const PlayService = {
  getConfig: async () => {
    const { data } = await ovpFetch('/play');
    return data;
  },
  updateConfig: async (payload) => {
    await ovpFetch('/play', {
      method: 'POST',
      iLikeItRaw: true,
      body: JSON.stringify(payload),
    });
    return true;
  },
  uploadLogo: async (payload) => {
    await ovpFetch('/play/upload/logo', {
      method: 'POST',
      body: payload,
      defaultContentType: true,
      iLikeItRaw: true,
    });
    return true;
  },
  uploadDefaultPoster: async (payload) => {
    await ovpFetch('/play/poster', {
      method: 'POST',
      body: payload,
      defaultContentType: true,
      iLikeItRaw: true,
    });
    return true;
  },
  getLVSPConfig: async () => {
    const { data } = await ovpFetch('/liveshopping/configuration');
    return data;
  },
  updateLVSPConfig: async (payload) => {
    const { data } = await ovpFetch('/liveshopping/configuration', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data;
  },
};

// eslint-disable-next-line
export { PlayService };
